const ContactsIndex = () => import('./views/ContactsIndex.vue')
const ContactsCreate = () => import('./views/ContactsCreate.vue')
const ContactsEdit = () => import('./views/ContactsEdit.vue')

export default [
  {
    path: 'contacts',
    name: 'contacts.index',
    component: ContactsIndex
  },
  {
    path: 'contacts/create',
    name: 'contacts.create',
    component: ContactsCreate
  },
  {
    path: 'contacts/:contactId(\\d+)',
    name: 'contacts.edit',
    component: ContactsEdit
  }
]
